module.exports = __webpack_public_path__ + "static/media/Bills_header_history.c7803680.svg";